import type {Canvas} from '@postermywall/fabricjs-2';

/** Sets the cursor fabric falls back to for the idle, hover and move states. */
export const setCanvasCursor = (canvas: Canvas, cursor: string): void => {
  canvas.defaultCursor = cursor;
  canvas.hoverCursor = cursor;
  canvas.moveCursor = cursor;
};

/**
 * Sets the cursor showing right now alongside the fallback states.
 * No-ops once the canvas is disposed: fabric releases `upperCanvasEl` on dispose, so a deferred
 * `setCursor` (a timer or a listener that outlives the editor) would throw on its `style`.
 */
export const applyCanvasCursor = (canvas: Canvas, cursor: string): void => {
  if (canvas.disposed === true || canvas.destroyed === true) {
    return;
  }
  setCanvasCursor(canvas, cursor);
  canvas.setCursor(cursor);
};
